import type { SVGProps } from "react";
export interface LocationStarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LocationStarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LocationStarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 10c0-3.63-3.095-6.875-6.876-6.875-3.78 0-6.874 3.245-6.874 6.875v.547l.012.41c.118 2.039 1.107 3.997 2.41 5.712 1.383 1.817 3.037 3.25 4.085 4.07a.58.58 0 0 0 .737 0c1.048-.82 2.7-2.253 4.082-4.07 1.39-1.829 2.424-3.935 2.424-6.122zm2.25.547c0 2.884-1.348 5.467-2.882 7.484-1.543 2.029-3.36 3.599-4.487 4.481a2.834 2.834 0 0 1-3.511 0c-1.128-.882-2.944-2.452-4.487-4.48-1.439-1.892-2.713-4.28-2.867-6.947l-.016-.538V10c0-4.839 4.069-9.125 9.124-9.125 5.057 0 9.126 4.286 9.126 9.125z"
      />
      <path
        fill={color}
        d="M10.878 5.954a1.376 1.376 0 0 1 2.243 0l.106.177.838 1.667 1.882.27.199.043c.961.284 1.349 1.538.557 2.297l-1.35 1.292.318 1.823c.202 1.158-1.016 1.948-1.983 1.448l-1.689-.871-1.686.871c-.968.5-2.185-.29-1.983-1.448l.316-1.823-1.35-1.292c-.844-.81-.346-2.183.757-2.34l1.882-.27.838-1.667zm.803 3.38c-.165.33-.48.558-.845.61l-.672.095.473.453c.27.259.393.636.33 1.005l-.116.663.632-.326.125-.056c.295-.11.625-.09.908.056l.633.326-.116-.663c-.064-.37.06-.746.331-1.005l.472-.453-.671-.095a1.13 1.13 0 0 1-.847-.61L12 8.7l-.318.634Z"
      />
    </svg>
  );
}
